// Library methods
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DefaultModal from "../../../modals/DefaultModal/DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "src/styles/mui/muiStylesHelper";

type SignOutModalType = {
  open: boolean;
  onClose: () => void;
  onConfirm: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const SignOutModal = ({ open, onClose, onConfirm }: SignOutModalType) => {
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("Sign Out")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
          }}
        >
          <Button sx={ModalCustomCancel} onClick={onClose}>
            {t("Cancel")}
          </Button>
          <Button sx={ModalCustomConfirm} onClick={onConfirm}>
            {t("Sign Out")}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="16px" gap="20px">
        <Typography>{t("Are you sure you want to sign out?")}</Typography>
      </Grid>
    </DefaultModal>
  );
};

export default SignOutModal;
